import { render, staticRenderFns } from "./inscriptions-list.vue?vue&type=template&id=9506a616&"
import script from "./inscriptions-list.vue?vue&type=script&lang=js&"
export * from "./inscriptions-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports